import { Dc_Text_Glossar_Unsynced } from "@op/sf-op/components/Dc_Text_Glossar_Unsynced";
import type { GlossaryItemMarkProps } from "../../../../../renderer/RichTextRenderer/marks/GlossaryItemMark";
import { useMemo } from "react";
import { useContent } from "@op/utils/src/hooks";

const GlossaryItemMark = ({ uniqueId, children }: GlossaryItemMarkProps) => {
  const { glossaryItems } = useContent();

  const glossaryItem = useMemo(() => {
    return glossaryItems.find((g) => g.uniqueId === uniqueId);
  }, [glossaryItems, uniqueId]);

  if (!glossaryItem) return null;
  return (
    <Dc_Text_Glossar_Unsynced
      text={children}
      tooltipContent={glossaryItem.definition}
    />
  );
};

export default GlossaryItemMark;
